// test1832
(1832 && 0);
